import { Tooltip } from "antd";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { InfoCircleFilled } from "@ant-design/icons";
import {
  formatNumber,
  getPortfolioTypeTranslation,
} from "src/utils/helper/functions";

const AccountStructuredProducts: React.FC<any> = ({
  assets,
  view,
  seeFundDetails,
  setShowCashDetails,
  setShowAssetsDetails,
  setShowFundDetails,
}): any => {
  const [portfolioData, setPortfolioData] = useState<any>([]);
  const [activePortfolio, setActivePortfolio] = useState<any>(null);

  useEffect(() => {
    const groupedData = assets
      .filter((item: any) => item.productGroupName === "Structured Products")
      .reduce((acc: any, obj: any) => {
        const key = obj.portfolioCode;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(obj);
        return acc;
      }, {});

    setPortfolioData(groupedData);
  }, [assets]);

  useEffect(() => {
    if (Object.keys(portfolioData).length === 1) {
      setActivePortfolio(Object.keys(portfolioData)[0]);
    }
  }, [portfolioData]);

  const getSumission = (data: any[], key: string): number => {
    return data
      ?.reduce(
        (accumulator, currentValue) => accumulator + currentValue[key],
        0
      )
      ?.toFixed(3);
  };

  const onAccountDetailsClicked = (portfolioCode: any) => {
    if (portfolioCode === activePortfolio) {
      setActivePortfolio(null);
    } else {
      setActivePortfolio(portfolioCode);
    }
  };

  return portfolioData ? (
    <div
      id="srp"
      className="p-3 md:p-4 flex-1 bg-white rounded-xl add-shadow h-fit flex-col justify-start items-center gap-5 inline-flex slide-left"
    >
      <div className=" self-stretch flex-col justify-start items-center gap-3 flex">
        <div className=" self-stretch flex-col justify-start items-start gap-5 flex">
          <div className=" self-stretch flex-col justify-start items-start gap-5 flex">
            <div className="items-center gap-2 inline-flex w-full">
              <img
                src="/images/arrow-right.svg"
                className={clsx(
                  "cursor-pointer",
                  "rotate-180"
                )}
                width={24}
                height={24}
                alt="back"
                onClick={() => {
                  setShowCashDetails(false);
                  setShowAssetsDetails(false);
                  setShowFundDetails(false);
                }}
              />
              <div className=" flex grow text-[#2a2a2a] text-sm md:text-base font-bold">
                Structured Products
              </div>
            </div>
            <div className=" self-stretch flex-col justify-start items-start gap-3 flex">
              {Object.entries(portfolioData)?.map(([key, value]: any) => (
                <div key={key} className="flex flex-col w-full gap-3">
                  {view === "account" ? (
                    <div
                      className={clsx(
                        " cursor-pointer px-3 py-4 rounded-lg border-[1px] border-[#e3e3e3] flex-col justify-start items-start gap-4 flex",
                        activePortfolio === key
                          ? "bg-[#002f6c]"
                          : "bg-[#f6f6f6]"
                      )}
                      onClick={() => onAccountDetailsClicked(key)}
                    >
                      <div className="w-full flex-col justify-start items-start gap-2.5 flex">
                        <div className="w-full justify-start items-start gap-2 inline-flex">
                          <div className=" w-[18px] h-[18px] justify-center items-center flex">
                            {activePortfolio === key ? (
                              <img
                                src="/images/minus-icon.svg"
                                width={18}
                                height={18}
                                alt="minus"
                              />
                            ) : (
                              <img
                                src="/images/plus-icon.svg"
                                width={18}
                                height={18}
                                alt="plus"
                              />
                            )}
                          </div>
                          <div className=" w-full flex-col justify-start items-start gap-2 inline-flex">
                            <div className="w-full justify-between items-start w-380:items-center flex flex-col w-380:flex-row">
                              <div className=" justify-start items-center gap-1 flex">
                                <div
                                  className={clsx(
                                    " text-xs md:text-sm font-bold",
                                    activePortfolio === key
                                      ? "text-white "
                                      : "text-[#002f6c]"
                                  )}
                                >
                                  {key}
                                </div>
                                <div
                                  className={clsx(
                                    " opacity-70 text-[10px] md:text-xs font-normal",
                                    activePortfolio === key
                                      ? "text-white"
                                      : "text-[#2a2a2a]"
                                  )}
                                >
                                  (
                                  {

                                    getPortfolioTypeTranslation(
                                      value[0]?.portfolioGroupName
                                        ?.split("Portfolio")[0]
                                        ?.trim()
                                    )

                                  }
                                  )
                                </div>
                              </div>
                              <div
                                className={clsx(
                                  " text-xs md:text-sm font-bold",
                                  activePortfolio === key
                                    ? "text-white"
                                    : "text-[#535353]"
                                )}
                              >
                                {formatNumber(
                                  +getSumission(value, "reportingMarketAmount"),
                                  value[0]?.reportingCurrencyDcp
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {value?.map((item: any) => {
                    return (
                      <div
                        key={item?.id}
                        onClick={() => seeFundDetails(item)}
                        className={clsx(
                          "cursor-pointer self-stretch p-3 bg-[#fdfdfd] rounded-lg border border-[#e3e3e3]  gap-6",
                          activePortfolio == item.portfolioCode ||
                            view === "portfolio"
                            ? "flex flex-col justify-start items-start"
                            : "hidden"
                        )}
                      >
                        <div className=" self-stretch justify-between items-start inline-flex w-full">
                          <div className=" items-start flex flex-col">
                            <div className=" text-blue-500 text-xs md:text-[13px] font-semibold flex items-start gap-2">
                              {item?.disclaimerText && (
                                <Tooltip
                                  title={
                                    <ul>
                                      {item?.disclaimerText
                                        ?.split("#")
                                        ?.map((ele: any, index: number) => (
                                          <li key={index}>{ele}</li>
                                        ))}
                                    </ul>
                                  }
                                >
                                  <InfoCircleFilled
                                    className="cursor-pointer"
                                    style={{ color: "#ffa500" }}
                                  />
                                </Tooltip>
                              )}
                              {item[`secNameEn`]}{" "}
                            </div>
                          </div>
                          <div className="flex items-center gap-5">
                            {/* {Constants.redeemPortfolios?.includes(
                              item?.portfolioGroupCode
                            ) &&
                              Constants.assetsRefIds?.includes(
                                item?.assetRefrenceId
                              ) && (
                                <div className=" px-2 py-1 bg-[#ceeedf] rounded-[52px] justify-start items-center gap-1 flex">
                                  <div className=" text-center text-[#008331] text-xs font-semibold">
                                    {translationObject?.redeemable}
                                  </div>
                                </div>
                              )} */}
                            <div
                              className="cursor-pointer w-6 h-6 justify-center items-center flex"
                              onClick={() => seeFundDetails(item)}
                            >
                              <img
                                src="/images/arrow-right.svg"
                                width={24}
                                height={24}
                                alt="arrow"
                                className={clsx(
                                  "cursor-pointer",
                                )}
                              />
                            </div>
                          </div>
                        </div>
                        <div className=" self-stretch flex-col justify-start items-center gap-3 flex">
                          <div className=" self-stretch justify-between items-start flex flex-wrap gap-y-5">
                            <div className="w-[49%] md:w-[33%] flex-col justify-start items-start gap-2 inline-flex">
                              <div className=" self-stretch justify-start items-end gap-1 inline-flex">
                                <div className=" grow shrink basis-0 text-[#949494] text-xs font-semibold">
                                  Shares held
                                </div>
                              </div>
                              <div className="Frame6279 self-stretch justify-start items-center gap-1 inline-flex">
                                <div className="00000 text-[#535353] text-xs font-semibold">
                                  {formatNumber(
                                    item.quantity,
                                    item?.quantityDecimal
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="w-[49%] md:w-[33%] flex-col justify-start items-start gap-2 inline-flex">
                              <div className="Frame6263 self-stretch justify-start items-start gap-1 inline-flex">
                                <div className="MarketValue w-[170px] text-[#949494] text-xs font-semibold">
                                  Total market value
                                </div>
                              </div>
                              <div className=" self-stretch justify-start items-center gap-1 inline-flex">
                                <div className="00000 text-[#535353] text-xs font-semibold">
                                  {formatNumber(
                                    item?.investmentMarketAmount,
                                    item?.investmentCurrencyDcp
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="w-[49%] md:w-[33%] flex-col justify-start items-center gap-2 inline-flex">
                              <div className=" self-stretch justify-start items-start gap-1 inline-flex">
                                <div className="Currency grow shrink basis-0 text-[#949494] text-xs font-semibold">
                                  Inv. currency
                                </div>
                              </div>
                              <div className=" self-stretch justify-start items-center gap-1 inline-flex">
                                <div className="Sar text-[#535353] text-xs font-semibold">
                                  {item?.investmentCurrency}
                                </div>
                              </div>
                            </div>

                            <div className="w-[49%] md:w-[33%] flex-col justify-start items-start gap-2 inline-flex">
                              <div className=" self-stretch justify-start items-end gap-1 inline-flex">
                                <div className=" grow shrink basis-0 text-[#949494] text-xs font-semibold">
                                  Total cost
                                </div>
                              </div>
                              <div className="Frame6279 self-stretch justify-start items-center gap-1 inline-flex">
                                <div className="00000 text-[#535353] text-xs font-semibold">
                                  {formatNumber(
                                    item.investmentCost,
                                    item?.investmentCurrencyDcp
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="w-[49%] md:w-[33%] flex-col justify-start items-start gap-2 inline-flex">
                              <div className=" self-stretch justify-start items-end gap-1 inline-flex">
                                <div className=" grow shrink basis-0 text-[#949494] text-xs font-semibold">
                                  YTD - Income Distribution
                                </div>
                              </div>
                              <div className="Frame6279 self-stretch justify-start items-center gap-1 inline-flex">
                                <div className="00000 text-[#535353] text-xs font-semibold">
                                  {formatNumber(
                                    item.incomeDistributiontYtd,
                                    item?.investmentCurrencyDcp
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="w-[49%] md:w-[33%] flex-col justify-start items-start gap-2 inline-flex">
                              <div className=" self-stretch justify-start items-end gap-1 inline-flex">
                                <div className=" grow shrink basis-0 text-[#949494] text-xs font-semibold">
                                  % YTD Cash Yield
                                </div>
                              </div>
                              <div className="Frame6279 self-stretch justify-start items-center gap-1 inline-flex">
                                <div className="00000 text-[#535353] text-xs font-semibold">
                                  {formatNumber(
                                    item?.incomeDistributiontYtdPct,
                                    2
                                  )}
                                  %
                                </div>
                              </div>
                            </div>


                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    ""
  );
};

export default AccountStructuredProducts;
